import { createContext, useContext } from 'react';

interface SidebarUIContextValue {
  openEmojiId: string | null;
  setOpenEmojiId: (id: string | null) => void;
  openMenuId: string | null;
  setOpenMenuId: (id: string | null) => void;
}

export const SidebarUIContext = createContext<SidebarUIContextValue>({
  openEmojiId: null,
  setOpenEmojiId: () => null,
  openMenuId: null,
  setOpenMenuId: () => null,
});

export const useSidebarUI = () => useContext(SidebarUIContext);
